if (!customElements.get('bf-start-guide')) {
  class BfStartGuide extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-bf-start-tab]')];
      this.track = this.querySelector('.bf-start__track');
      this.slides = [...this.querySelectorAll('.bf-start__card')];
      this.prev = this.querySelector('.bf-start__prev');
      this.next = this.querySelector('.bf-start__next');
      this.count = this.slides.length;
      this.index = 0;
      this.category = '';
      this.touchX = 0;
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.prev?.addEventListener('click', () => this.go(this.index - 1), { signal });
      this.next?.addEventListener('click', () => this.go(this.index + 1), { signal });
      this.track?.addEventListener('transitionend', (event) => {
        if (event.target !== this.track || event.propertyName !== 'transform' || !this.outside()) return;
        this.index = this.wrap();
        this.update(false);
      }, { signal });
      this.track?.addEventListener('touchstart', (event) => {
        this.touchX = event.touches[0].clientX;
      }, { passive: true, signal });
      this.track?.addEventListener('touchend', (event) => {
        if (this.desktop()) return;
        const delta = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(delta) >= 40) this.go(this.index + (delta < 0 ? 1 : -1));
      }, { passive: true, signal });
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = this.slides.findIndex((slide) => slide.dataset.category === tab.dataset.category);
          if (index >= 0) this.go(this.loop() ? this.count + index : index);
        }, { signal });
      });
      window.addEventListener('resize', () => this.update(false), { signal });

      this.reveal();
      this.setupLoop();
      this.update(false);
    }

    disconnectedCallback() {
      this.abort.abort();
    }

    loop() {
      return this.count > 1;
    }

    desktop() {
      return matchMedia('(min-width: 990px)').matches;
    }

    motion() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    outside() {
      return this.index < this.count || this.index >= this.count * 2;
    }

    wrap(index = this.index) {
      return this.count + ((index % this.count) + this.count) % this.count;
    }

    setupLoop() {
      if (!this.track || !this.loop()) return;

      const copy = (slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.remove('is-active');
        [...clone.attributes].forEach(({ name }) => {
          if (name.startsWith('data-shopify')) clone.removeAttribute(name);
        });
        return clone;
      };
      const first = this.track.firstChild;
      this.slides.forEach((slide) => this.track.insertBefore(copy(slide), first));
      this.slides.forEach((slide) => this.track.appendChild(copy(slide)));
      this.index = this.count;
    }

    go(index) {
      if (!this.count) return;
      if (!this.loop()) {
        this.index = 0;
        this.update(false);
        return;
      }

      const animate = index >= 0 && index < this.count * 3 && !this.motion();
      this.index = animate ? index : this.wrap(index);
      this.update(animate);
    }

    update(animate) {
      const cards = this.track ? [...this.track.querySelectorAll('.bf-start__card')] : [];
      if (!this.track || !cards.length) return;
      if (!animate && this.loop() && this.outside()) this.index = this.wrap();

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const offset = (cards[0].getBoundingClientRect().width + gap) * this.index;
      this.track.style.transition = animate ? '' : 'none';
      this.track.style.transform = `translateX(-${offset}px)`;
      if (!animate) this.track.offsetWidth;

      if (this.prev) this.prev.disabled = !this.loop();
      if (this.next) this.next.disabled = !this.loop();
      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === this.index));
      this.setCategory(cards[this.index]?.dataset.category || '');
    }

    setCategory(category) {
      if (!category || category === this.category) return;
      this.category = category;

      let tab = null;
      this.tabs.forEach((item) => {
        const active = item.dataset.category === category;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) tab = item;
      });

      const list = tab?.parentElement;
      if (!list || this.desktop()) return;
      list.scrollTo({
        left: tab.offsetLeft - list.offsetLeft,
        behavior: this.motion() ? 'auto' : 'smooth'
      });
    }

    reveal() {
      if (this.motion()) return;
      this.slides.forEach((slide, index) => {
        slide.style.animation = 'none';
        slide.offsetWidth;
        slide.style.animation = `bf-start-in 0.45s ease ${index * 90}ms both`;
      });
    }
  }

  customElements.define('bf-start-guide', BfStartGuide);
}
